import { Injectable } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { GraphService } from 'src/app/kernel/graphql/services/graph.service';
import { first } from 'rxjs';
import {MutationResult} from "apollo-angular/types";

interface UtmParamsInterface {
  source?: string | null;
  utmMedium?: string | null;
  utmCampaign?: string | null;
  utmContent?: string | null;
  utmTerm?: string | null;
  cookie?: string | null;
}

@Injectable({
  providedIn: "root"
})
export class UtmTrackerService {

  private tracked = false ;

  constructor(
    private graphService: GraphService,
    private route: ActivatedRoute,
    private cookieService: CookieService,
    private router: Router
  ) {}

  extractUtmParams() {
    return {
      source: this.route.snapshot.queryParams['utm_source'],
      utmMedium: this.route.snapshot.queryParams['utm_medium'],
      utmCampaign: this.route.snapshot.queryParams['utm_campaign'],
      utmContent: this.route.snapshot.queryParams['utm_content'],
      utmTerm: this.route.snapshot.queryParams['utm_term'],
    }
  }

  hasUtmParams() {
    return Object.values(this.extractUtmParams()).some(param => Boolean(param));
  }

  trackUtmParams() {
    if (this.tracked || !this.hasUtmParams()) {
      return this.clearUtmParams() ;
    }
    this.saveUtmParams(this.extractUtmParams()).pipe(first()).subscribe({
      next: (data) => this.handleUtmSaveSuccess(data),
      error: (error) => this.handleUtmSaveError(error)
    });
  }

  handleUtmSaveSuccess(response: MutationResult<{ saveUtmTracker: { cookie: string } }>) {
    if (!response?.data?.saveUtmTracker?.cookie) {
      return
    }
    const domain = window.location.hostname.split('.').slice(-2).join('.');
    this.cookieService.set('utm_cookie', response.data.saveUtmTracker.cookie, 30, '/', domain);
    this.tracked = true;
    this.clearUtmParams();
  }

  clearUtmParams() {
    if (!this.hasUtmParams()) {
      return;
    }
    const queryParams = {...this.route.snapshot.queryParams};

    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    utmKeys.forEach(key => delete queryParams[key]);

    this.router.navigate([], {relativeTo: this.route, queryParams, replaceUrl: true});
  }

  handleUtmSaveError(error: any) {
    console.error(error);
  }

  private saveUtmParams(input: UtmParamsInterface) {
    return this.graphService.constructMutation<{ saveUtmTracker: { cookie: string }; }>(
      'saveUtmTracker',
      { utmInput: 'UtmInput!' },
      { utmInput: input },
      ['cookie']
    );
  }
}
